<template>
    <div
        :class="{
            'form__field--error' : errorMessage,
            ...getMdFieldClasses,
        }"
        class="form__field"
    >
        <label
            v-if="!isMdField"
            class="input__label capitalize"
        >
            {{ $t(label) }}
        </label>
        <div
            :class="{ 'input__field--prefixed' : prefix }"
            class="input__field-box"
        >
            <span
                v-if="prefix"
                class="input__prefix"
            >
                {{ prefix }}
            </span>
            <Icon
                v-if="isCheckmarkVisible"
                class="input__field--success icon-check"
            />
            <label
                v-if="isMdField"
                class="input__label capitalize"
            >
                {{ $t(label) }}
            </label>
            <input
                :class="{ 'input__field--error' : errorMessage }"
                class="input__field"
                :value="value"
                :name="inputName"
                v-bind="$attrs"
                @input="onFieldInput"
                @blur="onFieldBlur"
                @focus="onFieldFocus"
                ref="input"
            />
        </div>
        <div
            v-if="errorMessage"
            class="message message--error"
        >
            <Icon
                size="xs"
                class="icon-warning_triangle"
            />
            <span>
                {{ errorMessage }}
            </span>
        </div>
        <div
            v-if="infoMessage && !errorMessage"
            class="form__text"
        >
            {{ infoMessage }}
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import BaseInput from './BaseInput';

    export default Vue.component('CustomInput', {
        mixins: [BaseInput],
        props: {
            label: {
                type: String,
                required: false,
                default: '',
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
            infoMessage: {
                type: String,
                required: false,
                default: null,
            },
            prefix: {
                type: String,
                required: false,
                default: null,
            },
            isCheckmarkEnabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCheckmarkDisplayed: {
                type: Boolean,
                required: false,
                default: null,
            },
            isPendingValidation: {
                type: Boolean,
                required: false,
                default: false,
            },
            autofill: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                // field is needed because user can click on input without writing anything
                // but we want to show him an error if field is required
                isDirty: false,
                isFocused: false,
                isTouched: false,
            };
        },
        created() {
            this.inputName = this.autofill ? this.name : '';
        },
        computed: {
            isCheckmarkVisible() {
                if (this.isCheckmarkEnabled && this.isTouched && !this.isFocused) {
                    return (this.isValid && this.isCheckmarkDisplayed === null) || !!this.isCheckmarkDisplayed;
                } else {
                    return false;
                }
            },
            isValid() {
                return !this.errorMessage && this.value && this.isTouched && !this.isPendingValidation;
            },
            getMdFieldClasses() {
                return {
                    'form__field__md-field': this.isMdField,
                    'form__field__md-field--focused': this.isMdField && this.isFocused,
                    'form__field__md-field--filled': this.isMdField && !!this.value,
                    'form__field__md-field--error': this.isMdField && this.hasGeneralError,
                };
            },
        },
        methods: {
            focusInput() {
                this.$refs.input.focus();
            },
            onFieldBlur() {
                this.onBlur();
                this.isFocused = false;
            },
            onFieldInput(eventArgs) {
                this.onInput(eventArgs);
                this.isTouched = true;
            },
            onFieldFocus() {
                this.isFocused = true;
            },
        },
    });
</script>
